import { FunctionComponent, useState } from "react";
import Select, { MultiValue, SingleValue } from "react-select";
import { Guid } from "../../../api/baseApi";
import { DuplicateMediaInGroupsRequest, duplicateMediaInGroups } from "../../../api/channelsApi";
import { Button } from "../../components/Button";
import { FormInputNumber, FormRow } from "../../components/formRow/FormRow";
import { RightModal } from "../../components/sideModal/Modal";

type Option<T> = { value: T, label: string };

interface CloneMediaToGroupsModalProps {
    show: boolean;
    channelId: Guid;
    nestedPlaylistId: Guid;
    mediaId: Guid;
    hash: number;
    groups: Option<Guid>[];
    onCancel: () => void;
    onApproved: () => Promise<void>;
}

const countDuplicatedInGroupOptions: Option<number>[] = [
    {value: 1, label: "1"},
    {value: 2, label: "2"},
    {value: 3, label: "3"},
    {value: 4, label: "4"},
    {value: 5, label: "5"},
    {value: 6, label: "6"},
    {value: 7, label: "7"},
    {value: 8, label: "8"},
    {value: 9, label: "9"},
];

const CloneMediaToGroupsModal: FunctionComponent<CloneMediaToGroupsModalProps> = (props) => {
    let {show, channelId, nestedPlaylistId, mediaId, hash, groups, onCancel, onApproved} = props;

    let [selectedGroupIds, setSelectedGroupIds] = useState<Guid[]>([]);
    let [orderDuplicatedInGroups, setOrderDuplicatedInGroups] = useState<number | string>(1);
    let [countDuplicatedInGroups, setCountDuplicatedInGroups] = useState<number>(1);
    let [isSubmitting, setIsSubmitting] = useState(false);

    const resetState = () => {
        setSelectedGroupIds([]);
        setOrderDuplicatedInGroups(1);
        setCountDuplicatedInGroups(1);
        setIsSubmitting(false);
    };

    const cancel = () => {
        resetState();
        onCancel();
    };

    const onChangeSelectedGroups = (selectedGroups: MultiValue<Option<Guid>>) => {
        setSelectedGroupIds(selectedGroups.map(el => el.value));
    };

    const onChangeOrderDuplicatedInGroups = (newValue: string) => {
        if (newValue === "" || +newValue < 0) setOrderDuplicatedInGroups("");
        else setOrderDuplicatedInGroups(+newValue);
    };

    const onChangeCountDuplicatedInGroups = (option: SingleValue<Option<number>>) => {
        if (option) {
            setCountDuplicatedInGroups(option.value);
        }
    };

    const approve = async () => {
        let request: DuplicateMediaInGroupsRequest = {
            groupIds: selectedGroupIds,
            hash: hash,
            order: orderDuplicatedInGroups == "" ? null : +orderDuplicatedInGroups,
            count: countDuplicatedInGroups
        };

        setIsSubmitting(true);
        try {
            await duplicateMediaInGroups(request, channelId, nestedPlaylistId, mediaId);
            resetState();
            await onApproved();
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <RightModal title="Duplicate in Groups" show={show} onRequestClose={cancel}>
            <FormRow>
                <label>Groups</label>
                <Select
                    options={groups}
                    classNamePrefix={`select`}
                    onChange={onChangeSelectedGroups}
                    isClearable={true}
                    isMulti
                    value={groups.filter(group => selectedGroupIds.includes(group.value))}
                />
            </FormRow>
            <FormRow>
                <FormInputNumber
                    errorMessage=""
                    id="order_duplicated"
                    isError={false}
                    title="Order"
                    min={1}
                    onChangeValue={onChangeOrderDuplicatedInGroups}
                    onChange={() => {}}
                    value={orderDuplicatedInGroups}
                />
            </FormRow>
            <FormRow>
                <label>Number of Copies</label>
                <Select
                    options={countDuplicatedInGroupOptions}
                    classNamePrefix={`select`}
                    onChange={onChangeCountDuplicatedInGroups}
                    inputId="count_duplicated"
                    value={countDuplicatedInGroupOptions.find(o => o.value === countDuplicatedInGroups)}
                />
            </FormRow>
            <div className="modal-btn-group">
                <Button color="green" label="Save" onClick={approve} isDisabled={isSubmitting}/>
                <Button color="gray" label="Cancel" onClick={cancel}/>
            </div>
        </RightModal>
    );
};

export default CloneMediaToGroupsModal;
